import { MdAdd, MdAddLink, MdEdit,MdPlayArrow,MdOutlineWatch, MdDone ,MdCancel, MdOutlinePause, MdDelete, MdFormatListBulletedAdd } from "react-icons/md";

export default function  ToolbarOptionComponent({title, icon, clickAction, size}) {

    const toolbarOptionIcon = (()=>{
        switch(icon){
            case 'AddTask':
                return <MdAdd  title={title}  size={size}/>
            case 'AddBulkTask':
                return <MdFormatListBulletedAdd  title={title}  size={size}/>   
            case 'AddProject':
                return <MdAdd title={title}  size={size}/>
            case 'AddSubtask':
                return <MdAdd title={title}  size={size}/>
            case 'AddBulkSubtask':
                return <MdFormatListBulletedAdd  title={title}  size={size}/>   
            case 'AddResource':
                return <MdAddLink title={title}  size={size}/>
            case 'AddWorklog':
                return <MdOutlineWatch title={title} size={size}/>
            case 'Edit':
                return <MdEdit title={title} size={size} className="bg-blue-500 rounded-md" color="white"/>
            case 'Start':
                return <MdPlayArrow color="white"  title={title} size={size} className="bg-green-500 rounded-md"/>
            case 'Pause':
                return <MdOutlinePause color="white"  title={title} size={size} className="bg-orange-500 rounded-md"/>
            case 'Finish':
                return <MdDone color="white"  title={title} size={size} className="bg-purple-500 rounded-md"/>
            case 'Cancel':
                return <MdCancel color="white"  title={title} size={size} className="bg-red-500 rounded-md"/>                    
            case 'Delete':
                return <MdDelete title={title} size={size}/>                    
    
            }
    
    })
    return (
        <div className='mr-2'>
            <a href='#' className='cursor-pointer ' onClick={clickAction}>{toolbarOptionIcon()}</a>
        </div> 
    )
}